import { render, staticRenderFns } from "./CardModal.vue?vue&type=template&id=4504bb8f&"
import script from "./CardModal.vue?vue&type=script&lang=js&"
export * from "./CardModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CardModal.vue"
export default component.exports